import React from 'react';
import { Button } from '@mui/material';

function ButtonCommon(props) {
  const {
    autoFocus,
    backgroundColor,
    border,
    hoverBorder,
    disableElevation,
    size,
    customColor,
    variant,
    children,
    fontSize,
    fontWeight,
    marginLeft,
    onClick,
    type,
    sx,
    disabled,
    fullWidth,
  } = props;
  return (
    <Button
      {...props}
      autoFocus={autoFocus}
      size={size}
      variant={variant}
      disableElevation={disableElevation}
      onClick={onClick}
      type={type}
      disabled={disabled}
      fullWidth={fullWidth}
      sx={{
        minWidth: 120,
        textTransform: 'none',
        padding: '10px 32px',
        fontSize,
        fontWeight,
        marginLeft,
        color: customColor,
        border,
        '&:hover': {
          backgroundColor,
          border: hoverBorder,
        },
        '@media (max-width: 475px)': {
          marginLeft: '0',
          width: '100%',
          marginTop: '1rem',
        },
        ...sx,
      }}
    >
      {children}
    </Button>
  );
}

ButtonCommon.defaultProps = {
  size: 'small',
  variant: 'outlined',
  disableElevation: false,
  fontSize: 16,
  fontWeight: 'bold',
  marginLeft: 0,
  customColor: '#000000',
  border: 'inherit',
  hoverBorder: 'transparent',
  backgroundColor: '#FEBE10',
  disabled: false,
  fullWidth: false,
};

export default React.memo(ButtonCommon);
